import SmoothScroll from "../components/SmoothScroll";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../sections/Hero";
import EditorialMarquee from "../sections/Marquee";
import Manifesto from "../sections/Manifesto";
import Events from "../sections/Events";
import Join from "../sections/Join";
import SuggestionBoard from "../sections/SuggestionBoard";

export default function Landing() {
  return (
    <SmoothScroll>
      <div className="grain relative bg-wine-bg">
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <Manifesto />
          <Events />
          <SuggestionBoard />
          <Join />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
